import './answers-list.scss';
import { Dispatch, ReactElement, SetStateAction } from 'react';
import { IconButton, SVGIcon } from '@system1/lib-react';
import {
  AnswerInstance,
  ExistingQuestion,
} from 'components/configure-modals/configure-from-existing-questions/types';

interface AnswersListProps {
  selectedQuestion: ExistingQuestion;
  setSelectedQuestion: Dispatch<SetStateAction<ExistingQuestion>>;
  answers: AnswerInstance[];
}

export const AnswersList = ({
  selectedQuestion,
  setSelectedQuestion,
  answers,
}: AnswersListProps): ReactElement => {
  return (
    <div className="answers-list">
      <div className="answers-list__selected-question">
        <IconButton
          onClick={() => setSelectedQuestion(null)}
          type="extend"
          id="back-btn"
        />
        <div className="existing-question">
          <div className="existing-question__info">
            <div
              className="existing-question__name"
              title={selectedQuestion.questionName}
            >
              {selectedQuestion.questionName}
            </div>
            <div
              className="existing-question__description"
              title={selectedQuestion.questionText}
            >
              {selectedQuestion.questionText}
            </div>
          </div>
        </div>
      </div>
      {answers.length > 0 ? (
        <div className="answers-list__list">
          {answers.map((question) => (
            <div className="answers-list__item" key={question.id}>
              <SVGIcon src="/images/icons/lock.svg" />
              {question.text}
            </div>
          ))}
        </div>
      ) : (
        <div className="answers-list__not-available">
          No values available for this question.
        </div>
      )}
    </div>
  );
};
